jQuery(function($){
    // ===== Helpers & state =====
    function getContainer($el){ return $el.closest('.wbdm-grid, .product-subcategories-product-list-products-container'); }
    function getGrid($c){ return $c.find('ul.products').first(); }
    function getPager($c){ return $c.find('.products-toolbar-footer-pagination').first(); }
    function getToolbar($c){ return $c.find('.products-toolbar-footer').first(); }

    function shouldReload($el){
        const $footer = $el.closest('.products-toolbar-footer');
        const flag = $footer.attr('data-reload');
        if (flag !== undefined) return String(flag) === '1';
        const $b = $('body'); const url = new URL(window.location.href);
        const postType = url.searchParams.get('post_type');
        return $b.is('.post-type-archive-product, .tax-product_cat, .tax-product_tag') ||
            ($b.is('.search') && postType === 'product');
    }

    // true = we must fetch more items from server (AJAX) for this block container
    function needsAjax($c){
        const total = getTrueTotal($c);
        const inDom = getGrid($c).children('li.product').length;
        return total > inDom;
    }
    function getTrueTotal($c){
        const fromContainer = parseInt($c.attr('data-total') || $c.data('total') || 0, 10);
        const fromFooter    = parseInt(getToolbar($c).attr('data-total') || getToolbar($c).data('total') || 0, 10);
        return Math.max(fromContainer, fromFooter);
    }

    function getPerPage($c){
        const $sel = $c.find('.products-per-page-select').first();
        const $t   = getToolbar($c);
        return parseInt(($sel.val() || $t.attr('data-per-page')),10) || 12;
    }
    function getCurrentPage($c){
        const $t = getToolbar($c);
        return parseInt($t.data('paged') || $t.attr('data-paged') || 1, 10) || 1;
    }
    function setToolbarMeta($c, {perPage, paged, total}){
        const $t = getToolbar($c);
        if (perPage != null){ $t.data('per-page', perPage).attr('data-per-page', perPage); }
        if (paged   != null){ $t.data('paged', paged).attr('data-paged', paged); }
        if (total   != null){ $t.data('total', total).attr('data-total', total); $c.attr('data-total', total); }
    }

    // ===== Client-side filter/scope =====
    function parseFilterValue(val){
        if (!val) return [];
        if (val.indexOf('terms:') === 0) return val.slice(6).split('|').map(s=>s.trim()).filter(Boolean);
        if (val.indexOf('label:') === 0) return [val.slice(6)];
        return [val];
    }
    function collectFilters($c){
        return $c.find('select.attribute-select').toArray().map(sel=>{
            const terms = parseFilterValue(sel.value);
            return terms.length ? { tax: $(sel).data('attribute'), terms } : null;
        }).filter(Boolean);
    }
    function parseRange(str){
        if (!str) return null;
        const cleaned = String(str).replace(/[–—]/g, '-').replace(/,/g, '.');
        const m = cleaned.match(/([\d.]+)\s*-\s*([\d.]+)/);
        if (!m) return null;
        const a = parseFloat(m[1].replace(',','.'));
        const b = parseFloat(m[2].replace(',','.'));
        if (isNaN(a) || isNaN(b)) return null;
        return [Math.min(a,b), Math.max(a,b)];
    }
    function parseNumber(str){
        if (!str) return null;
        const cleaned = String(str).replace(/,/g, '.');
        const m = cleaned.match(/[\d.]+/);
        if (!m) return null;
        const n = parseFloat(m[0]);
        return isNaN(n) ? null : n;
    }
    function rangesOverlap(r1, r2){ return r1[0] <= r2[1] && r2[0] <= r1[1]; }
    function markFiltered($c){
        const filters = collectFilters($c);
        const $items  = getGrid($c).children('li.product');
        if (!filters.length){ $items.removeClass('is-filtered-out').addClass('is-filtered-in'); return; }
        $items.each(function(){
            const ok = filters.every(f=>{
                const raw = this.getAttribute('data-'+f.tax) || '';
                const terms = raw.split(/[,\s]+/).map(s=>s.trim()).filter(Boolean);
                return f.terms.some(selected=>{
                    const selRange = parseRange(selected);
                    if (selRange){
                        return terms.some(tok=>{
                            const tokRange = parseRange(tok);
                            if (tokRange) return rangesOverlap(selRange, tokRange);
                            const num = parseNumber(tok);
                            return num !== null && num >= selRange[0] && num <= selRange[1];
                        });
                    }
                    // exact match
                    return terms.includes(selected);
                });
            });
            this.classList.toggle('is-filtered-in',  !!ok);
            this.classList.toggle('is-filtered-out', !ok);
        });
    }
    function itemsInScope($c){
        const $in = getGrid($c).children('li.product.is-filtered-in');
        return $in.length ? $in : getGrid($c).children('li.product');
    }

    // ===== Client pager build/slice =====
    function setPagerCurrent($c, page){
        const $pager = getPager($c);
        $pager.find('.page-numbers').removeClass('current').removeAttr('aria-current');
        $pager.find(`.page-numbers[data-page="${page}"]`).addClass('current').attr('aria-current','page');
    }
    function renderPage($c, page){
        const per    = getPerPage($c);
        const $grid  = getGrid($c);
        const $all   = $grid.children('li.product');
        const $scope = itemsInScope($c);

        const total   = $scope.length;
        const pages   = Math.max(1, Math.ceil(total / per));
        const p       = Math.min(Math.max(parseInt(page,10)||1, 1), pages);

        $all.hide();
        const start = (p-1)*per;
        $scope.slice(start, start+per).show();

        setToolbarMeta($c, { perPage: per, paged: p, total: Math.max(getTrueTotal($c), total) });
        setPagerCurrent($c, p);
    }
    function rebuildPager($c, targetPage){
        const per         = getPerPage($c);
        const $scope      = itemsInScope($c);
        const hasAllItems = !needsAjax($c);
        const total       = hasAllItems ? $scope.length : getTrueTotal($c);
        const pages       = Math.max(1, Math.ceil(total / per));

        let p = parseInt(targetPage,10);
        if (isNaN(p) || p < 1) p = 1;
        if (p > pages) p = pages;

        const $pager = getPager($c).empty();

        const seq = [];
        for (let i=1; i<=Math.min(3,pages); i++) seq.push(i);
        const ws = Math.max(4, p-1);
        const we = Math.min(pages-3, p+1);
        for (let i=ws; i<=we; i++) seq.push(i);
        const startLast = Math.max(1, pages-2);
        for (let i=startLast; i<=pages; i++) seq.push(i);

        const uniq = [...new Set(seq.filter(n => n>=1 && n<=pages))].sort((a,b)=>a-b);

        function addLink(i,isCurrent){
            $('<a href="#" class="page-numbers"></a>')
                .attr('data-page', i)
                .toggleClass('current', !!isCurrent)
                .attr('aria-current', isCurrent ? 'page' : null)
                .text(i)
                .appendTo($pager);
        }
        function addDots(){ $('<span class="page-numbers dots">…</span>').appendTo($pager); }

        let prev = 0;
        uniq.forEach(i => { if (prev && i > prev + 1) addDots(); addLink(i, i===p); prev = i; });

        if (pages <= 1) $pager.hide(); else $pager.show();

        // In AJAX mode we only have the current page in DOM, so skip slicing/hiding.
        if (hasAllItems) {
            renderPage($c, p);
        } else {
            setToolbarMeta($c, { perPage: per, paged: p, total: total });
            setPagerCurrent($c, p);
        }
    }

    function updateResultCount($c){
        const per    = getPerPage($c);
        const $scope = itemsInScope($c);
        const total  = needsAjax($c) ? getTrueTotal($c) : ($scope.length || getTrueTotal($c));
        const paged  = getCurrentPage($c);
        const start  = total ? ((paged-1)*per + 1) : 0;
        const end    = Math.min(total, paged*per);
        const text   = total ? `Wyświetlanie ${start}–${end} z ${total} wyników` : 'Brak wyników';
        $c.find('.products-result-count, .products-toolbar-result-count').text(text);
    }

    // ===== AJAX loader for this block =====
    function collectSortValue($c){
        const v = $c.find('#sort').val();
        return v || 'date';
    }
    function currentTermId($c){
        // prefer active tab if present
        const $active = $c.find('.subcategory-tab.active');
        if ($active.length) return parseInt($active.data('term-id'), 10) || parseInt($c.attr('data-current-term'), 10);
        return parseInt($c.attr('data-current-term'), 10);
    }
    function loadBlockPage($c, paged, perPage){
        // use your existing AJAX action used in your codebase
        const termId = currentTermId($c);
        const layout = $c.find('ul.products').hasClass('list-view') ? 'list' : 'grid';
        const sort   = collectSortValue($c);

        return $.post(WBDM_loc.ajax_url, {
            action: 'load_products_by_subcategory',
            term_id: termId,
            layout: layout,
            per_page: perPage,
            paged: paged,
            sort: sort
        }, null, 'json').then(function(resp){
            if (!resp || !resp.success) throw new Error(resp && resp.data ? resp.data : 'AJAX failed');
            // Replace list
            $c.find('#subcategory-products').html(resp.data.html);
            // Update toolbar meta (total/per/paged)
            const total = parseInt(resp.data?.total || resp.data?.found_posts || getTrueTotal($c), 10);
            setToolbarMeta($c, { perPage: perPage, paged: paged, total: total });

            // If your server returns result_count/subcategory_title/description, refresh them
            if (resp.data?.result_count) $c.find('.products-result-count').text(resp.data.result_count);
            if (resp.data?.subcategory_title) $c.find('.product-subcategories-product-list__title').text(resp.data.subcategory_title);
            if (resp.data?.subcategory_description) $c.find('.product-subcategories-product-list__text').html(resp.data.subcategory_description);

            // Rebuild client pager for the newly injected set (we only have perPage items in DOM,
            // so pager in DOM will just be one page — that’s OK, the footer links stay clickable and keep AJAXing)
            // To allow client slicing within the returned page (e.g., after filters), mark+rebuild using new DOM.
            markFiltered($c);
            rebuildPager($c, paged);
            updateResultCount($c);
        });
    }

    // ===== Handlers =====

    // Per-page
    $(document).off('change.wbdmPerPage').on('change.wbdmPerPage', '.products-per-page-select', function(){
        const $sel = $(this);
        const $c   = getContainer($sel);

        // sync mirrored selects
        $c.find('.products-per-page-select').not($sel).val(this.value);

        if (shouldReload($sel)) {
            const url  = new URL(window.location.href);
            url.searchParams.set('per_page', this.value);
            url.searchParams.set('paged', 1);
            window.location.assign(url.toString());
            return;
        }

        const perPage = parseInt(this.value,10) || 12;

        if (needsAjax($c)) {
            // Ask server for page 1 with new perPage
            loadBlockPage($c, 1, perPage);
        } else {
            // Everything is in DOM → just slice
            setToolbarMeta($c, { perPage: perPage, paged: 1 });
            markFiltered($c);
            rebuildPager($c, 1);
            updateResultCount($c);
        }
    });

    // Pagination click
    $(document)
        .off('click.wbdmPager', '.products-toolbar-footer-pagination .page-numbers')
        .on('click.wbdmPager', '.products-toolbar-footer-pagination .page-numbers', function(e){
            const $link = $(this);
            const $c = getContainer($link);
            const page = parseInt($link.attr('data-page'), 10) || 1;

            if (shouldReload($link)) {
                const href = this.getAttribute('href');
                e.stopImmediatePropagation();
                if (href && href !== '#') { window.location.assign(href); return; }
                const url = new URL(window.location.href);
                url.searchParams.set('paged', page);
                window.location.assign(url.toString());
                return;
            }

            e.preventDefault();

            if (needsAjax($c)) {
                const perPage = getPerPage($c);
                loadBlockPage($c, page, perPage);
            } else {
                renderPage($c, page);
                updateResultCount($c);
            }
        });

    // Attribute filters (client if we have all items; otherwise you may extend your AJAX to accept filters)
    $(document).off('change.wbdmAttr').on('change.wbdmAttr', 'select.attribute-select', function(){
        const $c = getContainer($(this));
        if (shouldReload($(this))) return;
        if (needsAjax($c)) {
            // Optional: extend your AJAX to accept selected filter params and call loadBlockPage with those.
            // For now, we apply filters on the current DOM only:
        }
        markFiltered($c);
        rebuildPager($c, 1);
        updateResultCount($c);
    });

    // Sorting
    $(document).off('change.wbdmSort').on('change.wbdmSort', '#sort', function(){
        const $c = getContainer($(this));
        if (shouldReload($(this))) {
            const url = new URL(window.location.href);
            url.searchParams.set('sort', this.value);
            url.searchParams.set('paged', 1);
            window.location.assign(url.toString());
            return;
        }
        if (needsAjax($c)) {
            // Ask the server for sorted page 1
            const perPage = getPerPage($c);
            loadBlockPage($c, 1, perPage);
            return;
        }
        // Client sort on DOM
        const $grid = getGrid($c);
        const crit  = this.value;
        const items = $grid.children('li.product').detach().get();
        let sorted = items;
        if (crit === 'price_asc')       sorted = items.sort((a,b)=> +$(a).data('price') - +$(b).data('price'));
        else if (crit === 'price_desc') sorted = items.sort((a,b)=> +$(b).data('price') - +$(a).data('price'));
        else if (crit === 'popularity') sorted = items.sort((a,b)=> +$(a).data('sales') - +$(b).data('sales'));
        else if (crit === 'rating')     sorted = items.sort((a,b)=> +$(a).data('rating') - +$(b).data('rating'));
        else                            sorted = items.sort((a,b)=> new Date($(b).data('date')) - new Date($(a).data('date')));
        $grid.append(sorted);
        markFiltered($c);
        rebuildPager($c, getCurrentPage($c));
        updateResultCount($c);
    });

    // Init
    (function init(){
        $('.product-subcategories-product-list-products-container, .wbdm-grid').each(function(){
            const $c = $(this);
            // If archive/search/reload, do nothing client-side
            if (shouldReload($c.find('.products-toolbar-footer'))) {
                getGrid($c).children('li.product').show();
                return;
            }
            // For block:
            markFiltered($c);
            // If we currently only have a partial DOM (needsAjax), just set counts and don't try to slice invisible pages
            if (needsAjax($c)) {
                const current = getCurrentPage($c);
                setToolbarMeta($c, { perPage: getPerPage($c), paged: current, total: getTrueTotal($c) });
                setPagerCurrent($c, current);
                updateResultCount($c);
            } else {
                const initial = parseInt(getToolbar($c).attr('data-paged'), 10) || 1;
                rebuildPager($c, initial);
                updateResultCount($c);
            }
        });
    })();
});
